import React from 'react'
import cx from 'classnames'

import s from './BurgerMenu.scss'


const BurgerMenu = ({ className, color = 'white', isToggleActive, onClick }) => (
  <div
    className={cx(s.burgerMenu, className, {
      [s.active]: isToggleActive,
      [s[color]]: color,
    })}
    onClick={onClick}
  >
    <span />
  </div>
)


export default BurgerMenu
